<template>
  <div>
    <Head title="Invoices" />
    <h1 class="mb-8 text-3xl font-bold">Invoices</h1>
    <div class="flex items-center justify-between mb-6">
      <search-with-dropdown-filter v-model="search.search" class="mr-4 w-full max-w-md">
      </search-with-dropdown-filter>
      <select-input v-model="search.status" class="mr-4 w-3/4 max-w-md">
        <option :value="null">-Select Status-</option>
        <option v-for="item in statuses" :key="item" :value="item">{{ item }}</option>
      </select-input>
      <date-range
        v-model="search.dateValue"
        class="mr-0 w-full max-w-md"
        @reset="reset"
      />
    </div>
    <hr />
    <div class="flex items-center justify-between mt-5">
      <a
        v-if="invoices.data.length > 0 && url()"
        class="btn-orange px-3 py-2 text-xs cursor-pointer"
        :href="`/invoices/download${url()}`"
        download
        target="__blank"
        title="Download"
      >
        <span>Download</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
      <!--I want to see the Invoice Date, Invoice Number, Amount, Response, Processing, Created By-->
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Invoice Date</th>
          <th class="pb-3 pt-3 px-3">Invoice Number</th>
          <th class="pb-3 pt-3 px-3 items-end justify-end float-right">Amount</th>
          <th class="pb-3 pt-3 px-3">Response</th>
          <th class="pb-3 pt-3 px-3">Processing</th>
          <th class="pb-3 pt-3 px-3">Created By</th>
        </tr>
        <tr
          v-for="invoice in invoices.data"
          :key="invoice.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <span
              class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
              @click="openModal(invoice)"
            >
              {{ invoice.date }}
            </span>
          </td>
          <td class="border-t">
            <span
              class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
              @click="openModal(invoice)"
            >
              {{ invoice.invoice_no }}
            </span>
          </td>
          <td class="border-t">
            <span
              class="flex items-end justify-end px-3 py-3 focus:text-orange-500 cursor-pointer"
              @click="openModal(invoice)"
            >
              {{ invoice.amount }}
            </span>
          </td>
          <td class="border-t">
            <span
              class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
              @click="openModal(invoice)"
            >
              {{ invoice.message }}
            </span>
          </td>
          <td class="border-t">
            <span
              class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
              @click="openModal(invoice)"
            >
              {{ invoice.processing }}
            </span>
          </td>
          <td class="border-t">
            <span
              class="flex items-center px-3 py-3 focus:text-orange-500 cursor-pointer"
              @click="openModal(invoice)"
            >
              {{ invoice.user }}
            </span>
          </td>
        </tr>
        <tr v-if="invoices.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="9">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="invoices.links" />
  </div>
  <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div
            class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full"
          >
            <h1>{{ invoiceNo }} - {{ orderNo }}</h1>
          </div>
          <div
            v-if="details.length > 0"
            class="w-full bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4"
          >
            <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
              <div class="grid grid-cols-1 gap-4 p-1">
                <div class="pt-2 p-2">
                  <h1 style="font-size: 20px; font-weight: bold">Invoice Details</h1>
                </div>
              </div>
            </div>
            <div class="flex mb-4 overflow-x-auto">
              <table class="w-full whitespace-nowrap" style="width: 100%">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">#</th>
                  <th class="pb-3 pt-3 px-3">SKU</th>
                  <th class="pb-3 pt-3 px-3">Description</th>
                  <th class="pb-3 pt-3 px-3">Qty</th>
                  <th class="pb-3 pt-3 px-">Unit Price</th>
                  <th class="pb-3 pt-3 px-">Discount (%)</th>
                  <th class="pb-3 pt-3 px-3 text-end">Amount</th>
                </tr>
                <tr v-for="(item, index) in details" :key="index">
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ index + 1 }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.name }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.description }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">{{
                      item.quantity
                    }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">{{
                      item.sales_price
                    }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ item.discount_rate }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 text-end justify-end">{{
                      item.amount
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="w-px border-t pb-3 pt-3"></td>
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3">SubTotal</td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 items-end justify-end">{{
                      payments.sub_total
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="w-px border-t pb-3 pt-3"></td>
                  <td class="w-px border-t pb-3 pt-3" />
                  <th class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3">VAT</td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 items-end justify-end">{{
                      payments.vat
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="w-px border-t pb-3 pt-3"></td>
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3">Total</td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 items-end justify-end">{{
                      payments.gross_amount
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="w-px border-t pb-3 pt-3"></td>
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3">Paid</td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 items-end justify-end">{{
                      payments.payment
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="w-px border-t pb-3 pt-3"></td>
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3" />
                  <td class="w-px border-t pb-3 pt-3">Balance</td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 items-end justify-end"
                      ><strong>{{ payments.balance }}</strong></span
                    >
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span
              v-if="!taxillaStatus"
              class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
            >
              <button
                class="btn-orange px-3 py-2 text-xs cursor-pointer ml-1 mr-1"
                @click="retryValidation(invoiceId, invoiceNo, 'taxilla')"
              >
                Retry By Taxilla
              </button>
            </span>
            <span
              v-if="!taxillaStatus"
              class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
            >
              <button
                class="btn-orange px-3 py-2 text-xs cursor-pointer ml-1 mr-1"
                @click="retryValidation(invoiceId, invoiceNo, 'direct')"
              >
                Retry By Direct
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <a
                v-show="false"
                class="btn btn-orange text-xs cursor-pointer ml-1 mr-1"
                :href="`/orders/${orderId}/pdf${pdfUrl(orderId)}`"
                download
                target="__blank"
                title="Download"
              >
                <span>Prevalidated Invoice</span>
              </a>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <a
                v-if="
                  (user.per_user_permissions.includes('view_invoices') ||
                    user.group_permissions.includes('view_invoices') ||
                    user.role === 'admin') &&
                  taxillaStatus == 'completed' &&
                  taxillaValidationStatus === 'Validation Complete'
                "
                class="btn btn-orange text-xs cursor-pointer ml-1 mr-1"
                :href="`/download-taxilla-pdf-invoices/${invoiceId}`"
                target="__blank"
                title="Download"
              >
                <span>Validated Invoice</span>
              </a>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                v-if="
                  (user.per_user_permissions.includes('view_invoices') ||
                    user.group_permissions.includes('view_invoices') ||
                    user.role === 'admin') &&
                  invoiceClosed == 'Open'
                "
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 ml-1 mr-1"
                @click="addPayment(orderId)"
              >
                Add Payment
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                v-show="false"
                v-if="
                  (user.per_user_permissions.includes('view_invoices') ||
                    user.group_permissions.includes('view_invoices') ||
                    user.role === 'admin') &&
                  taxillaStatus != 'completed' &&
                  taxillaValidationStatus != 'Validation Complete'
                "
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 ml-1 mr-1"
                @click="initiateTaxilla(invoiceId)"
              >
                Validate
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeModal"
              >
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div
    v-if="showAddPayment && invoiceClosed == 'Open'"
    class="fixed z-10 inset-0 overflow-y-auto"
  >
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-3/4"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 class="text-3xl font-bold">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
                style="display: inline !important"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
                />
              </svg>

              Add Payment Details
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <form @submit.prevent="store">
                <div>
                  <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-8 pb-8">
                    <p class="pb-1">Select Mode of Payment</p>
                    <multiselect
                      id="provider"
                      v-model="formPaymentData.payment_provider"
                      placeholder="Search Mode of Payment"
                      :options="providers"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :searchable="true"
                      class="mt-1 w-1/2"
                      :close-on-select="true"
                      :create-option="true"
                      :error="$props.errors.payment_provider"
                      :style="
                        $props.errors.payment_provider
                          ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)'
                          : ''
                      "
                      @select="onSelect"
                    />
                    <p v-if="$props.errors" class="text-red-700 pt-2">
                      <small>{{ $props.errors.payment_provider }}</small>
                    </p>
                  </div>
                  <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-2">
                    <text-input
                      v-model="formPaymentData.date"
                      type="date"
                      :error="$props.errors.date"
                      class="pb-8 pr-6 w-1/3 lg:w-1/3"
                      label="Date"
                    />
                    <text-input
                      v-model="formPaymentData.reference"
                      :error="$props.errors.reference"
                      class="pb-8 pr-6 w-1/3 lg:w-1/3"
                      label="Reference"
                    />
                    <text-input
                      v-model="formPaymentData.amount"
                      type="number"
                      :error="$props.errors.amount"
                      class="pb-8 pr-6 w-1/3 lg:w-1/3"
                      label="Amount"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="storePayment"
              >
                Submit
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closePaymentModal"
              >
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="showAddTaxilla" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <p>
                You are about to send the invoice <strong>{{ invoiceNo }}</strong> data to
                Taxilla. Do you wish to continue?
              </p>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                @click="closeTaxillaModal"
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
              >
                Cancel
              </button>
            </span>
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                @click="storeTaxilla()"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5"
              >
                Save
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import pickBy from "lodash/pickBy";
import Layout from "@/Shared/Layout";
import throttle from "lodash/throttle";
import mapValues from "lodash/mapValues";
import SearchWithDropdownFilter from "@/Shared/SearchWithDropdownFilter";
import Pagination from "@/Shared/Pagination";
import Multiselect from "@vueform/multiselect";
import SelectInput from "@/Shared/SelectInput";
import DateRange from "@/Shared/DateRange";
import TextInput from "@/Shared/TextInput";

export default {
  components: {
    Head,
    Link,
    SearchWithDropdownFilter,
    Pagination,
    SelectInput,
    DateRange,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    filters: Object,
    invoices: Object,
    errors: Object,
    statuses: Array,
    providers: Object,
  },
  data() {
    return {
      search: {
        search: this.filters.search,
        status: this.filters.status,
        dateValue: this.filters.dateValue,
      },
      isOpen: false,
      isValidated: true,
      orderNo: null,
      orderId: null,
      payments: null,
      orderType: null,
      invoiceId: null,
      invoiceClosed: "Open",
      taxillaStatus: null,
      taxillaValidationStatus: null,
      showAddPayment: false,
      showAddTaxilla: false,
      formPaymentData: {
        date: null,
        reference: null,
        amount: null,
        payment_provider: null,
      },
      formTaxillaData: {
        id: null,
      },
    };
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user;
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get("/invoices", pickBy(this.search), { preserveState: true });
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null);
    },
    openModal(data) {
      this.isOpen = true;
      this.details = data.details;
      this.invoiceNo = data.invoice_no;
      this.invoiceId = data.id;
      this.orderNo = data.order_no;
      this.orderId = data.order_id;
      this.payments = data.payments;
      this.invoiceClosed = data.status;
      this.taxillaStatus = data.taxilla_status;
      this.taxillaValidationStatus = data.taxilla_validation_status;
      this.orderType = data.payments.order_type;
    },
    closeModal(data) {
      this.isOpen = false;
      this.details = data.details;
    },
    addPayment(item) {
      this.showAddPayment = true;
      this.formPaymentData.order_id = item;
    },
    initiateTaxilla(item) {
      this.showAddTaxilla = true;
      this.taxillaStatus = data.status;
      this.formTaxillaData.id = item;
    },
    closePaymentModal() {
      this.showAddPayment = false;
    },
    closeTaxillaModal() {
      this.showAddTaxilla = false;
    },
    storePayment() {
      this.formPaymentData._method = "post";
      this.$inertia.post("/order-payments", this.formPaymentData, {
        onSuccess: () => {
          this.formPaymentData.date = null;
          this.formPaymentData.amount = null;
          this.formPaymentData.payment_provider = null;
          this.formPaymentData.reference = null;
          this.showAddPayment = false;
          this.isOpen = false;
        },
      });
    },
    storeTaxilla() {
      this.formTaxillaData._method = "post";
      this.$inertia.post(
        `/push-taxilla-invoices/${this.invoiceId}`,
        this.formTaxillaData,
        {
          onSuccess: () => {
            this.formTaxillaData.id = null;
            this.showAddTaxilla = false;
            this.taxillaStatus = null;
            this.isOpen = false;
          },
        }
      );
    },
    retryValidation(invoiceId, number, processingBy) {
      if (confirm(`Are you sure you want to resend this Invoice ${number}?`)) {
        this.formTaxillaData.id = invoiceId;
        this.formTaxillaData.processing_by = processingBy;
        this.formTaxillaData._method = "post";
        this.$inertia.post(`/push-taxilla-invoices/${invoiceId}`, this.formTaxillaData, {
          onSuccess: () => {
            this.formTaxillaData.id = null;
          },
        });
      }
    },
    url() {
      let query = "";
      if (this.search.search) {
        query += `search=${this.search.search}`;
      }
      if (this.search.dateValue) {
        if (query) {
          query += "&";
        }
        query += `dateValue=${this.search.dateValue}`;
      }
      if (this.search.status) {
        if (query) {
          query += "&";
        }
        query += `status=${this.search.status}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
    pdfUrl(orderId) {
      let query = "";
      if (orderId) {
        query += `oid=${orderId}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
.multiselect-option.is-selected.is-pointed {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}
.multiselect-option.is-selected {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}
.modal-wrapper h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}
</style>
